import React from "react";

const PreLoader = ({ className }) => {
  return (
    <>
      <div className={className ? className : "preloader"}>
        <div className="loader">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
      </div>
    </>
  );
};

export default PreLoader;
